import * as React from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { GlobalApplicationState } from 'globalApplicationState';
import { TopicDetails } from 'modules/topics';
import { TagStats } from 'modules/insights';
import TopicViewDetailsBody from './topicViewDetailsBody';
import MoreOptions from '../../buttons/moreOptions';

import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle, IconButton } from '@mui/material';
import { CloseIcon } from 'tinacms';
import Loading from 'modules/common/components/loading';
import SuccessSnackbar from 'modules/common/components/snackbars/successSnackbar';
import { insightsApi } from 'api/instances';
import { SNACKBAR_TIME_MS } from 'modules/topics/styles/constants';

const TopicViewDetails: React.FunctionComponent<PropsWithRedux> = (props) => {
    const [topicStats, setTopicStats] = React.useState<TagStats | null>(null);
    const [successMessage, setSuccessMessage] = React.useState("");

    const handleClose = () => props.onClose();

    const getSuccessMessage = (): string => `Your report is being generated and will be emailed to ${props.currentUser?.email} when it's ready.`;

    const onReport = () => setSuccessMessage(getSuccessMessage());

    React.useEffect(() => {
        const fetchTopicStats = async (topicId: string) => {
            const newStats = await insightsApi.GetSpecificTagStats(topicId);
            setTopicStats(newStats);
        };

        if (!topicStats && props.topic && props.show) fetchTopicStats(props.topic.id);
    }, [topicStats, props.topic, props.show]);

    const getDialogHeader = (): JSX.Element =>
        <DialogTitle className="audience-dialog-title">
            View Details

            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>

                {
                    !!props.topic &&
                    <MoreOptions
                        topic={props.topic}
                        closeDialog={handleClose}
                        onEdit={props.onEdit}
                        onMove={props.onMove}
                        onReport={onReport} />
                }

                <IconButton onClick={handleClose} style={{ float: "right" }} size="medium">
                    <CloseIcon />
                </IconButton>
            </div>
        </DialogTitle>;

    return (
        <Dialog
            open={props.show}
            maxWidth={false}
            scroll="paper"
            onClose={handleClose}
            classes={{ paper: "audience-dialog" }}
        >
            {getDialogHeader()}
            <DialogContent className={"dialog-content"}>
                {
                    !props.topic
                        ? <Loading />
                        : <TopicViewDetailsBody
                            stats={topicStats}
                            topic={props.topic}
                            onReport={onReport} />
                }
            </DialogContent>

            <SuccessSnackbar
                successMessage={successMessage}
                clearSuccessMessage={() => setSuccessMessage("")}
                autoHideDuration={SNACKBAR_TIME_MS}
            />
        </Dialog>
    );
};

interface ComponentProps {
    topic?: TopicDetails,
    show: boolean,
    onClose: () => void,
    onEdit: () => void,
    onMove: () => void,
}

const connector = connect(
    (state: GlobalApplicationState, ownProps: ComponentProps) => ({
        ...ownProps,
        currentUser: state.settings.currentUser
    })
);

type PropsWithRedux = ConnectedProps<typeof connector>;

export default connector(TopicViewDetails);